import React, { forwardRef } from "react";

import { SearchFieldAutocomplete } from "./search-field-autocomplete";
import {
  type SearchFieldAutocompleteEnhancements,
  SearchFieldBase,
  type SearchFieldBaseProps,
  searchFieldVariants,
} from "./search-field-base";

export { searchFieldVariants };

export type SearchFieldProps = SearchFieldBaseProps & SearchFieldAutocompleteEnhancements;

export const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>((props, ref) => {
  if (props.suggestions) {
    return <SearchFieldAutocomplete ref={ref} {...props} />;
  }

  return <SearchFieldBase ref={ref} {...props} />;
});

SearchField.displayName = "SearchField";

export {
  SearchFieldAutocomplete,
  type SearchFieldAutocompleteProps,
} from "./search-field-autocomplete";
